import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';
import { FAQQuestions } from 'src/utils/dummy/faq/content';

const HeadC = dynamic(() => import('src/components/Head'));
const FAQPageJsonLdC = dynamic(() => import('src/components/Layout/JsonLd/FAQ'));
const FaqContainer = dynamic(() => import('src/containers/Faq'));

const FaqPage = () => {
	return (
		<>
			<HeadC
				title="FAQ dan Pusat Bantuan Layanan di KlikDokter"
				description={
					'Pusat bantuan dan Frequently Asked Questions (FAQ) terkait layanan-layanan ' +
					'di KlikDokter. Simak pertanyaan yang banyak ditanyakan seputar layanan di sini.'
				}
				hideSuffix
			/>
			<FaqContainer />

			<FAQPageJsonLdC items={FAQQuestions.slice(0, 5)} />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {
			pageHeader: true,
			pageHeaderContent: null,
			jsonLd: {
				organization: true,
			},
		},
	};
});

export default FaqPage;
